import {BaseComponent} from "../../../../components/BaseComponent";
import React from "react";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {createStructuredSelector} from "reselect";
import {connect} from "react-redux";
import {HBox} from "../../../../components/Box";
import {Plus, Times} from "../../../../components/Icon";
import {InvoiceTransportLocationSelection} from "./InvoiceTransportLocationSelection";
import {InvoiceAddress} from "./InvoiceAddress";

const STATE = {
  showLocationSelection: false,
};

class InvoiceTransportLocationComp extends BaseComponent {

  constructor(props) {
    super(props);
  }

  onResetLocation() {
    this.props.onChange(null);
  }

  onChange(location) {
    this.onCloseSelection();
    this.props.onChange(location);
  }

  onEditLocation() {
    this.updateState('showLocationSelection', true);
  }

  onCloseSelection() {
    this.updateState('showLocationSelection', false);
  }

  render() {
    if (this.state.showLocationSelection) {
      return <InvoiceTransportLocationSelection
                          onChange={this.onChange.bind(this)}
                          onClose={this.onCloseSelection.bind(this)}
                          companyId={this.props.companyId} />
    }
    if (this.props.transportLocation) {
      return (
        <HBox>
          <InvoiceAddress address={this.props.transportLocation} />
          <Times onClick={this.onResetLocation.bind(this)} />
        </HBox>
      );
    }

    return (
      <Plus onClick={this.onEditLocation.bind(this)} />
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InvoiceTransportLocation = compose(
  withConnect,
  withRouter,
)(InvoiceTransportLocationComp);
